import StatusLoader from './StatusLoader';

const ReviewingApplicationLoader = () => (
  <StatusLoader
    src="/animation/lottie/_application-reviewing.json"
    text="Hang tight while we submit your application for review."
    title="Sending your application..."
  />
);

export default ReviewingApplicationLoader;
